module.exports = __webpack_public_path__ + "static/media/theme-modern-small.8572f6da.png";